import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {NotificationService} from "../../services/NotificationService";
import {GpsLocationHistoryService} from "../../services/GpsLocationHistoryService";
import {ReportAssetsModelBase} from "./ReportAssetsModelBase";

export class ReportGpsLocationHistoryModel extends ReportAssetsModelBase{
    static $inject = ['$q','FileSaver','Blob','GpsLocationHistoryService','CustomFieldNameService','NotificationService'];
    errorMessage:string = "";
    constructor(public $q:ng.IQService,
                public fileSaver:any,
                public blob:any,
                public gpsLocationHistoryService:GpsLocationHistoryService,
                public cfnService:CustomFieldNameService,
                public notifyService:NotificationService) {
        super();
        this.getCount();
        this.showTagType = false;
    }
    getReportName():String{
        return "GPS Location History Asset Report";
    }
    getReport():ng.IPromise<any>{

        return this.gpsLocationHistoryService.getReport(true, this.name,this.location,this.assetType,this.department,this.disposalStatus,this.checkedinStatus,this.missing).then((data)=>{
            var blob = new Blob([data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            this.fileSaver.saveAs(blob, 'gpsLocationHistory_by_asset.xlsx');
        })
            .catch((exc)=>{
                this.notifyService.notify("getReport err:"+exc);
            });
        return this.$q.when();
    }
    
    getCount():ng.IPromise<any>{
        //alert(this.location);
        return this.gpsLocationHistoryService.getReportCount(true, this.name,this.location,this.assetType,this.department,this.disposalStatus,this.checkedinStatus,this.missing)
            .then((data)=>{
                this.totalCount = data;
            }).catch((exc)=>{
                this.notifyService.notify("Exception in getCount-"+exc);
            });
    }

}

